module.exports = __webpack_public_path__ + "static/media/card_mc.51fedc2d.svg";